import { FreddieFloatPayment } from './FreddieFloatPayment';

export default FreddieFloatPayment;
